<template>
  <transition name="up">
    <div class="buy-modal" v-show="visible">
      <div class="mask" @click.self="close"></div>
      <div class="content">
        <div class="header">购买 <span @click.stop="close"></span></div>
        <div class="d-flex d-flex--middle detail">
          <div
            class="avatar"
            :style="{ backgroundImage: `url(${data.image})` }"
          ></div>
          <div>
            <div class="text-bold">{{ data.productName }}</div>
            <div class="desc">{{ data.user_name }}</div>
          </div>
        </div>
        <div class="pay">
          应支付 <span>￥{{ data.price }}</span>
        </div>
        <div class="submit" :class="{ disabled: loading }" @click="createOrder">
          立即购买
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mixin } from "@/components/Explain";

export default {
  props: {
    visible: Boolean,
    price: String,
    data: Object,
  },
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    visible() {
      document.body.style.overflow = this.visible ? "hidden" : null;
    },
  },
  mixins: [mixin],
  methods: {
    async createOrder() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      try {
        const { user, id } = this.$store.state;
        const data = await this.$http.post(
          "/wx/createOrder",
          {
            memberId: user.id,
            phone: user.phone,
            productIds: this.$route.params.id,
            jid: localStorage.getItem('jid'),
          },
          {
            slient: true,
          }
        );
        console.log(data)
        var wxpay = {
          appId:data.appId,
          timestamp: data.timeStamp,
          nonceStr: data.nonceStr,
          package: data.package,
          signType: data.signType,
          paySign: data.paySign,
          success: function(res) {
            if(res.errMsg == "chooseWXPay:ok"){           
              console.log('支付成功')
              window.location.reload();
            }
            else{         
                this.loading = false;    
                window.location.reload();
            }
          }
        };
			window.wx.ready(() => {
        window.wx.chooseWXPay(wxpay);
      })
        this.loading = false;
      } catch (err) {
        this.loading = false;
      }
    },

    onBridgeReady(wxpay) {
      window.WeixinJSBridge.invoke("getBrandWCPayRequest", wxpay, function(
        res
      ) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        }
      });
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.buy-modal {
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    content: "";
    z-index: 12;
    z-index: 100;
  }
  .detail {
    background: #f8f5f0;
    padding: 20px;
    .avatar {
      width: 67px;
      height: 90px;
      background: #ccc no-repeat center;
      background-size: cover;
      margin-right: 25px;
    }
    .desc {
      color: #999;
      font-size: 24px;
    }
  }
  .pay {
    text-align: center;
    font-size: 40px;
    color: #333;
    font-weight: 500;
    margin: 25px 0;
    margin-top: 80px;
    span {
      color: $detail-pay-btn;
    }
  }
  .header {
    padding: 30px;
    margin: -30px -20px;
    margin-bottom: 30px;
    line-height: 1;
    border-bottom: solid 1px #ddd;
    display: flex;
    justify-content: space-between;
    font-weight: 500;
    align-items: center;
    font-size: 32px;
    color: #333;
    span {
      content: "";
      width: 30px;
      height: 30px;
      display: inline-block;
      background: url(~@/assets/close2.png) no-repeat center;
      background-size: contain;
    }
  }
  .content {
    z-index: 9999;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fffcf8;
    padding: 30px 20px;
  }
}
.submit {
  background: $detail-pay-btn;
  border-radius: 100px;
  text-align: center;
  color: #fff;
  line-height: 80px;
  margin: 0 80px;
  margin-bottom: 10px;
  font-size: 32px;
  font-weight: 500;
  box-shadow: 0 5px 20px $detail-pay-btn;
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
